export const highlightTitle = (
	title: string,
	termsToHighlight: { [key: string]: string[] },
	phrasesToHighlight: object
) => {
	const terms = Object.keys(termsToHighlight)
		? Object.keys(termsToHighlight).reduce((r: string[], k) => {
				const nestedTerms = termsToHighlight[k].map((term) =>
					term.replace(/(\w+|d\+)/g, "\\b$1\\b")
				);
				return r.concat(k.replace(/(\w+|d\+)/g, "\\b$1\\b"), nestedTerms);
		  }, [])
		: [];
	/**
	 * phrases can be: {"exchange traded fund": [], 'exchange traded': []};
	 * titles with hyphens can trigger the highlight
	 * replace spaces with spaces and hyphens and add word boundaries
	 * Example titles:
	 * Dimensional Fund Advisors Lists Active *Exchange-Traded* Funds
	 * Equity Investing with Dimensional in a Mutual Fund versus *Exchange-Traded Fund*
	 * Dimensional to Launch *Exchange Traded* Funds in the US
	 */
	const phrases = Object.keys(phrasesToHighlight)
		? Object.keys(phrasesToHighlight).map((key) => {
				const newString = key.replace(/(.*?)\s+/g, "\\b$1\\b(\\s|-)");
				const newPhrase = newString.replace(/(\w+|\d+)$/g, "\\b$1\\b");
				//Example: ["\bexchange\b(\s|-)\btraded\b(\s|-)\bfund\b", "\bexchange\b(\s|-)\btraded\b"]
				return newPhrase;
		  })
		: [];
	const searchTerms = terms.concat(phrases);
	if (searchTerms.length) {
		const re = new RegExp(searchTerms.join("|"), "gi");
		return title.replace(re, (matched) => `<span>${matched}</span>`);
	}
	return title;
};
